import { render } from "./ProjectInput.vue?vue&type=template&id=72959ac7&scoped=true&ts=true"
import script from "./ProjectInput.vue?vue&type=script&lang=ts"
export * from "./ProjectInput.vue?vue&type=script&lang=ts"

import "./ProjectInput.vue?vue&type=style&index=0&id=72959ac7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72959ac7"]])

export default __exports__